<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">บันทึกข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_delete === true">ลบข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="pa-1">
          <div class="text-right ma-2">
            <v-btn x-large class="text-center grad-success-bg white--text btn_size" @click="rate_modal = true">เพิ่มเรทค่าจัดส่ง</v-btn>
          </div>
          <div class="pa-2">
            <v-data-table :headers="header" :items="data_list" :footer-props="footer_Props" mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td>
                    <div v-if="dataDetail.item.rate_type === 1">{{ dataDetail.item.name }}</div>
                    <div v-else>
                      <div v-if="dataDetail.item.rate_start <= (dataDetail.item.rate_start + '.00')">น้อยกว่าเท่ากับ {{ dataDetail.item.rate_start }}</div>
                      <div v-else-if="dataDetail.item.rate_start >= (dataDetail.item.rate_start + '.01') && dataDetail.item.rate_start <= (dataDetail.item.rate_start + '.99')">มากกว่าเท่ากับ {{ dataDetail.item.rate_start }}</div>
                    </div>
                  </td>
                  <td>{{ format_price(dataDetail.item.rate_price) }}</td>
                  <td class="pa-2">
                    <v-btn small height="42" @click="get_edit(dataDetail.item.id)" class="grad-warning-bg white--text mr-1 mb-1" title="แก้ไขข้อมูล">
                      <v-icon>mdi-note-edit-outline</v-icon>
                    </v-btn>
                    <v-btn small height="42" @click="remove_item(dataDetail.item.id)" class="grad-danger-bg white--text mb-1" title="ลบ">
                      <v-icon>mdi-delete-empty-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </div>
      </v-card>
      <v-dialog v-model="rate_modal" max-width="700">
        <v-card>
          <v-form ref="rate_add" @submit.prevent="save_data">
            <div class="d-flex justify-space-between">
              <v-card-title>
                เพิ่มเรทค่าจัดส่ง
              </v-card-title>
              <v-btn icon class="ma-4" @click="rate_modal = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <v-radio-group v-model="send_data.rate_status" mandatory>
                <div class="grid_radio mt-n5">
                  <div class="d-flex">
                    <div>
                      <v-radio color="#86bc3a" :value="1"></v-radio>
                    </div>
                    <div>กำหนดเอง</div>
                  </div>
                  <div class="d-flex">
                    <div>
                      <v-radio color="#86bc3a" :value="2"></v-radio>
                    </div>
                    <div>น้อยกว่าเท่ากับ</div>
                  </div>
                  <div class="d-flex">
                    <div>
                      <v-radio color="#86bc3a" :value="3"></v-radio>
                    </div>
                    <div>มากกว่าเท่ากับ</div>
                  </div>
                </div>
              </v-radio-group>
              <div class="grid_half" v-if="send_data.rate_status === 1">
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="number" label="จำนวนกิโลกรัมเริ่มต้น" @keypress="onlyNumber($event, send_data.min_kg)" v-model="send_data.min_kg" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="number" label="จำนวนกิโลกรัมสิ้นสุด" @keypress="onlyNumber($event, send_data.max_kg)" v-model="send_data.max_kg" hide-details="auto" outlined></v-text-field>
                </div>
              </div>
              <div v-else>
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="number" label="จำนวนกิโลกรัม" @keypress="onlyNumber($event, send_data.min_kg)" v-model="send_data.min_kg" hide-details="auto" outlined></v-text-field>
                </div>
              </div>
              <div class="grid_full">
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="number" label="ราคาค่าส่ง (บาท)" @keypress="onlyNumber($event, send_data.shipping_cost)" v-model="send_data.shipping_cost" :rules="[v => !!v || 'กรุณากรอกราคาค่าส่ง (บาท)']" required hide-details="auto" outlined></v-text-field>
                </div>
              </div>
              <div class="text-center mt-6">
                <v-btn small height="42" class="white--text grad-success-bg btn_size" style="font-size: 16px" type="submit">บันทึก</v-btn>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="rate_edit_modal" max-width="700">
        <v-card>
          <div v-if="loading_data === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <v-form ref="edit_rate" @submit.prevent="save_edit">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  แก้ไขเรทค่าจัดส่ง
                </v-card-title>
                <v-btn icon class="ma-4" @click="rate_edit_modal = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <v-radio-group v-model="edit_data.rate_type" mandatory>
                  <div class="grid_radio mt-n5">
                    <div class="d-flex">
                      <div>
                        <v-radio color="#86bc3a" :value="1"></v-radio>
                      </div>
                      <div>กำหนดเอง</div>
                    </div>
                    <div class="d-flex">
                      <div>
                        <v-radio color="#86bc3a" :value="2"></v-radio>
                      </div>
                      <div>น้อยกว่าเท่ากับ</div>
                    </div>
                    <div class="d-flex">
                      <div>
                        <v-radio color="#86bc3a" :value="3"></v-radio>
                      </div>
                      <div>มากกว่าเท่ากับ</div>
                    </div>
                  </div>
                </v-radio-group>
                <div class="grid_half" v-if="edit_data.rate_type === 1">
                  <div class="mt-3 ma-1">
                    <v-text-field color="#86bc3a" type="number" label="จำนวนกิโลกรัมเริ่มต้น" @keypress="onlyNumber($event, edit_data.rate_start)" v-model="edit_data.rate_start" hide-details="auto" outlined></v-text-field>
                  </div>
                  <div class="mt-3 ma-1">
                    <v-text-field color="#86bc3a" type="number" label="จำนวนกิโลกรัมสิ้นสุด" @keypress="onlyNumber($event, edit_data.rate_end)" v-model="edit_data.rate_end" hide-details="auto" outlined></v-text-field>
                  </div>
                </div>
                <div v-else>
                  <div class="mt-3 ma-1">
                    <v-text-field color="#86bc3a" type="number" label="จำนวนกิโลกรัม" @keypress="onlyNumber($event, edit_data.rate_start)" v-model="edit_data.rate_start" hide-details="auto" outlined></v-text-field>
                  </div>
                </div>
                <div class="grid_full">
                  <div class="mt-3 ma-1">
                    <v-text-field color="#86bc3a" type="number" label="ราคาค่าส่ง (บาท)" @keypress="onlyNumber($event, edit_data.rate_price)" v-model="edit_data.rate_price" :rules="[v => !!v || 'กรุณากรอกราคาค่าส่ง (บาท)']" required hide-details="auto" outlined></v-text-field>
                  </div>
                </div>
                <div class="text-center mt-6">
                  <v-btn small height="42" class="white--text grad-success-bg btn_size" style="font-size: 16px" type="submit">บันทึก</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </div>
        </v-card>
      </v-dialog>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import {formatPrice, onlyForCurrency} from "@/js/handler";
import Swal from "sweetalert2";
import {HTTP} from "@/axios";
// import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Rate_setting",
  data() {
    return {
      loading_page: false,
      loading_data: false,
      overlay: false,
      alert_success: false,
      alert_delete: false,
      rate_modal: false,
      rate_edit_modal: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      send_data: {
        rate_status: null,
        min_kg: '',
        max_kg: '',
        shipping_cost: '',
      },
      edit_data: [],
      header: [
        {
          text: 'จำนวนกิโลกรัม',
          value: '',
          fixed: true,
          width: '300px',
        },
        {
          text: 'ราคาค่าส่ง',
          value: '',
          fixed: true,
          width: '300px',
        },
        {
          text: 'จำนวนกิโลกรัม',
          value: '',
          sortable: false,
          fixed: true,
          width: '400px',
        },
      ],
      data_list: [],
    }
  },
  methods: {
    format_price: function(number) {
      return formatPrice(number)
    },
    onlyNumber: function(evt, number) {
      return onlyForCurrency(evt, number)
    },
    get_all() {
      this.loading_page = true
      HTTP.post('/manage-website/rates/all')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.data_list = res.data.object
            }
          })
    },
    save_data() {
      if (this.$refs.rate_add.validate()) {
        this.rate_modal = false
        this.overlay = true
        HTTP.post('/manage-website/rates/create', {
          rate_type: this.send_data.rate_status,
          rate_start: this.send_data.min_kg,
          rate_end: this.send_data.max_kg,
          rate_price: this.send_data.shipping_cost,
        }).then((res) => {
          if (res.data.success === true) {
            this.send_data.rate_status = null
            this.send_data.min_kg = ''
            this.send_data.max_kg = ''
            this.send_data.shipping_cost = ''
            this.overlay = false
            this.get_all()
            this.alert_success = true
            setTimeout(() => this.alert_success = false, 3000)
          }
        })
      }
    },
    get_edit(id) {
      this.rate_edit_modal = true
      this.loading_data = true
      HTTP.post('/manage-website/rates/get', {
        id: id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_data = false
          this.edit_data = res.data.object
        }
      })
    },
    save_edit() {
      if (this.$refs.edit_rate.validate()) {
        HTTP.post('/manage-website/rates/update', {
          id: this.edit_data.id,
          rate_type: this.edit_data.rate_type,
          rate_start: this.edit_data.rate_start,
          rate_end: this.edit_data.rate_end,
          rate_price: this.edit_data.rate_price,
        }).then((res) => {
          if (res.data.success === true) {
            this.rate_edit_modal = false
            this.get_all()
            this.alert_success = true
            setTimeout(() => this.alert_success = false, 3000)
          }
        })
      }
    },
    remove_item(id) {
      Swal.fire({
        title: 'คุณต้องการลบช้อมูลหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          HTTP.post('/manage-website/rates/delete', {
            id: id
          }).then((res) => {
            if (res.data.success === true) {
              this.get_all()
              this.alert_delete = true
              setTimeout(() => this.alert_delete = false, 3000)
            }
          })
        }
      })
    },
  },
  mounted() {
    this.get_all()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.btn_size {
  width: 25%;
}
.grid_radio {
  display: flex;
  justify-content: space-around;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
@media only screen and (max-width: 500px) {
  .grid_radio {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .btn_size {
    width: 100%;
  }
}
</style>
